import requests, { AUTH_SERVICE_URL } from './Setup'

const obligationTypes = {
  IVA: 0,
  ISLRAdvance: 1,
  ISLRRetention: 2,
  IGTF: 3,
  AnnualISLR: 4
}

const FiscalCalendar = {
  getCompanySchedule: (year) =>
    requests.get(`${AUTH_SERVICE_URL}/FiscalCalendar/CompanySchedule`, { params: { year } })
      .then(response => response?.data),
  getCompanyAlerts: () =>
    requests.get(`${AUTH_SERVICE_URL}/FiscalCalendar/CompanyAlerts`)
      .then(response => response?.data),
  markCompleted: (entryId, notes) =>
    requests.post(`${AUTH_SERVICE_URL}/FiscalCalendar/Completions/${entryId}`, { Notes: notes })
      .then(response => response?.data),
  unmarkCompleted: (entryId) =>
    requests.del(`${AUTH_SERVICE_URL}/FiscalCalendar/Completions/${entryId}`)
      .then(response => response?.data),
  getUpcoming: (countryId, year, rifLastDigit) =>
    requests.get(`${AUTH_SERVICE_URL}/FiscalCalendar/Upcoming/${countryId}/${year}`, {
      params: rifLastDigit != null ? { rifLastDigit } : undefined
    }).then(response => response?.data),
  getDueDate: (countryId, obligation, year, month, rifLastDigit) =>
    requests.get(`${AUTH_SERVICE_URL}/FiscalCalendar/DueDate/${countryId}/${obligation}/${year}/${month}/${rifLastDigit}`)
      .then(response => response?.data),
  getImpositivePeriod: (countryId, date) =>
    requests.get(`${AUTH_SERVICE_URL}/FiscalCalendar/ImpositivePeriod/${countryId}/${date}`)
      .then(response => response?.data),
  obligationTypes
}

export default FiscalCalendar
